import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Vehicle } from 'rest-client';

@Component({
  selector: 'bkg-summary-vehicle',
  templateUrl: './summary-vehicle.component.html',
})
export class SummaryVehicleComponent {
  @Input() vehicle: Vehicle;
  @Input() readOnly: boolean;

  @Output() changeVehicleReturn = new EventEmitter<boolean>();
  @Output() modifyVehicleKmReturn = new EventEmitter<Vehicle>();
  @Output() modifyVehicleReturn = new EventEmitter<Vehicle>();

  onClickModifyVehicle(): void {
    this.modifyVehicleReturn.emit(this.vehicle);
  }

  onClickModifyVehicleKm(): void {
    this.modifyVehicleKmReturn.emit(this.vehicle);
  }

  onClickChangeVehicle(openDialog:boolean): void {
    this.changeVehicleReturn.emit(openDialog);
  }
  get isRegisteredVehicle(): boolean {
    return this.vehicle?.id_client > 1;
  }
}
